/**
 * Given a Client Y coordinate, calculate it's distance
 * from the top of a parent element
 *
 * @param y        The clientY coordinate
 * @param parent   The HTMLElement to calculate offset from
 */
export function offsetRelativeToParent(
  y: number,
  parent: HTMLElement | null
) {
  if (parent) {
    const next = y - parent.offsetTop + parent.scrollTop
    return offsetRelativeToParent(
      next,
      parent.offsetParent as HTMLElement
    )
  } else {
    return y
  }
}
